export const MAX_FILE_SIZE = 1024 * 1024 * 50 // 50 mb
